import React, { Component } from 'react';

class Export extends Component {
    state = {
        format: 'json',
        startDate: '',
        endDate: '',
        loading: false,
        error: null,
        exportData: null
    };

    handleInputChange = (e) => {
        this.setState({ 
            [e.target.name]: e.target.value,
            exportData: null,
            error: null
        });
    };

    handleExport = async (e) => {
        e.preventDefault();
        
        this.setState({ loading: true, error: null });
        
        try {
            const { format, startDate, endDate } = this.state;
            
            const params = new URLSearchParams();
            params.append('format', format);
            if (startDate) params.append('start_date', startDate);
            if (endDate) params.append('end_date', endDate);
            
            const url = `${process.env.REACT_APP_API_URL}/api/account/export?${params.toString()}`;
            
            const response = await fetch(url, {
                method: 'GET',
                credentials: 'include',
                mode: 'cors',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Cache': 'no-cache'
                }
            });
            
            const result = await response.json();
            
            if (result.msg === 'Export ready') {
                this.setState({ 
                    exportData: result.data,
                    loading: false 
                });
            } else {
                this.setState({ 
                    error: 'Export failed',
                    loading: false 
                });
            }
        } catch (error) {
            this.setState({ 
                error: 'Error generating export',
                loading: false 
            });
        }
    };

    handleDownload = () => {
        const { exportData, format } = this.state;
        
        if (!exportData) return;
        
        let content, filename, type;
        
        if (format === 'csv') {
            content = exportData;
            filename = `penchukbank_transactions_${new Date().toISOString().split('T')[0]}.csv`;
            type = 'text/csv';
        } else {
            content = JSON.stringify(exportData, null, 2);
            filename = `penchukbank_transactions_${new Date().toISOString().split('T')[0]}.json`;
            type = 'application/json';
        }
        
        const blob = new Blob([content], { type });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
    };

    render() {
        const { format, startDate, endDate, loading, error, exportData } = this.state;

        return (
            <section className="export">
                <h2>Export Transactions</h2>
                <p className="description">
                    Download your transaction history in JSON or CSV format.
                </p>
                
                <form onSubmit={this.handleExport} className="export-form">
                    <div className="form-row">
                        <div className="form-group">
                            <label htmlFor="format">Export Format</label>
                            <select
                                id="format"
                                name="format"
                                value={format}
                                onChange={this.handleInputChange}
                                className="form-control"
                            >
                                <option value="json">JSON</option>
                                <option value="csv">CSV</option>
                            </select>
                        </div>
                    </div>
                    
                    <div className="form-row">
                        <div className="form-group">
                            <label htmlFor="startDate">Start Date (Optional)</label>
                            <input
                                type="date"
                                id="startDate"
                                name="startDate"
                                value={startDate}
                                onChange={this.handleInputChange}
                                className="form-control"
                            />
                        </div>
                        
                        <div className="form-group">
                            <label htmlFor="endDate">End Date (Optional)</label>
                            <input
                                type="date"
                                id="endDate"
                                name="endDate"
                                value={endDate}
                                onChange={this.handleInputChange}
                                className="form-control"
                            />
                        </div>
                    </div>
                    
                    <div className="export-actions">
                        <button 
                            type="submit" 
                            className="btn btn-primary"
                            disabled={loading}
                        >
                            {loading ? 'Generating...' : 'Generate Export'}
                        </button>
                    </div>
                </form>
                
                {error && (
                    <div className="alert alert-danger">{error}</div>
                )}
                
                {exportData && (
                    <div className="export-result">
                        <h3>Export Ready</h3>
                        <p>
                            {format === 'json' 
                                ? `${exportData.total_transactions || 0} transactions ready for download.`
                                : 'Your CSV file is ready for download.'
                            }
                        </p>
                        <button 
                            className="btn btn-success"
                            onClick={this.handleDownload}
                        >
                            Download {format.toUpperCase()}
                        </button>
                        
                        {format === 'json' && (
                            <div className="export-preview">
                                <h4>Preview</h4>
                                <pre className="json-preview">
                                    {JSON.stringify(exportData, null, 2).substring(0, 1000)}
                                    {JSON.stringify(exportData, null, 2).length > 1000 && '...'}
                                </pre>
                            </div>
                        )}
                    </div>
                )}
            </section>
        );
    }
}

export default Export;

